<template>
  <div>
    <i class="fa fa-spin fa-circle-o-notch" v-if="loading" />
    <div class="form-group" v-else>
      <p class="form-text">
        <span v-if="integration.id && !success">
          {{ __('Erro ao conectar a API, atualize esta página ou') }}
          <a href="#" @click.prevent="updating = !updating">
            {{ __('clique aqui e adicione o token novamente') }}
          </a>
          .
        </span>
        <span v-if="integration.id && success">
          {{ __('Integração configurada. Caso queira alterar') }}
          <a href="#" @click.prevent="updating = !updating">
            {{ __('clique aqui') }}
          </a>
          .
        </span>
        <span v-if="!integration.id">
          {{
            __(
              'Para configurar a integração com a Memberkit adicione seu token abaixo e clique em salvar.',
            )
          }}
        </span>
      </p>
      <form @submit.prevent="save()" v-if="!integration.id || updating">
        <label class="lg">Token</label>
        <p>
          <input
            class="form-control"
            type="text"
            v-model="config.token"
            :placeholder="tokenPlaceholder"
            :readonly="locked"
          />
        </p>
        <div class="text-right">
          <p>
            <button
              class="btn btn-sm btn-box"
              type="submit"
              :disabled="disabled || locked"
            >
              {{ __('Salvar') }}
            </button>
          </p>
        </div>
        <p class="form-text">
          {{
            __(
              'O token pode ser encontrado no seu painel da Memberkit, em Configurações',
            )
          }}
          <i class="fa fa-angle-double-right" />
          {{ __('Gerais') }}.
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import Integrations from '../../mixins/integrations';

export default {
  mixins: [Integrations],

  data() {
    return {
      config: {
        options: {
          all: false,
        },
      },
      integration: {
        name: 'memberkit',
      },
    };
  },

  computed: {
    disabled() {
      return this.config.token.length < 24 && !this.integration.id;
    },
  },
};
</script>
